<template>
  <div class="max-w-sm w-[90%] bg-white border border-gray-200 rounded-lg shadow-md anim">
    <img
      class="rounded-t-lg max-h-40 w-full"
      :src="
        sectors.image && sectors.image !== '[]' ?
        imageServe + sectors.image : 
        defaultBg
      "
      alt="foto do setor"
    />

    <div class="flex justify-end px-4 py-2">
      <button
        :id="'dropdownButton'+sectors.id"
        :data-dropdown-toggle="'dropdown'+sectors.id"
        class="inline-block text-gray-500 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg text-sm p-1.5"
        type="button"
      >
        <span class="sr-only">Open dropdown</span>
        <svg
          class="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 16 3"
        >
          <path
            d="M2 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6.041 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM14 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z"
          />
        </svg>
      </button>

      <!-- options -->
      <div
        :id="'dropdown'+sectors.id"
        class="z-10 hidden text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-44 border"
      >
        <ul class="py-2" :aria-labelledby="'dropdownButton'+sectors.id">
          <li>
            <a
              @click="$emit('setUpdateForm', sectors.id)"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
              >
              Alterar
            </a>
          </li>
          <li>
            <a
              @click="$emit('export', sectors.id)"
              class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer"
              >Exportar</a
            >
          </li>
          <li>
            <a
              @click="removeSector(sectors.id)"
              class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer"
              >Remover</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div class="px-2 pb-2 -mt-4">
      <a>
        <h5 class="mb-2 text-xl font-bold tracking-tight text-gray-900 grid">
          {{ sectors.name }}
          <small class="text-gray-300 text-xs font-medium tracking-wider">
            prioridade do setor 
            <small :class="[
              JSON.parse(sectors.priority).value == 'baixa'      ? 'text-gray-400' : '',
              JSON.parse(sectors.priority).value == 'media'      ? 'text-green-500' : '',
              JSON.parse(sectors.priority).value == 'alta'       ? 'text-red-500 font-semibold' : '',
              JSON.parse(sectors.priority).value == 'muito_alta' ? 'text-red-700 font-bold' : '',
            ]"> {{ JSON.parse(sectors.priority).name }} </small>
          </small>
        </h5>
      </a>

      <!-- statistics -->
      <p class="mb-3 font-normal text-gray-700">
        <div class="flex items-center">
          <div class="h-2.5 w-2.5 rounded-full me-2 bg-green-500"></div>
          equipamentos: 
          <label class="text-green-500 font-semibold ml-2"> 
            {{ sectors.itens_total }} 
          </label>
        </div>
        
        <div class="flex items-center">
          <div class="h-2.5 w-2.5 rounded-full me-2 bg-yellow-500"></div>
          a vencer: 
          <label class="text-yellow-500 font-semibold ml-2"> 
            {{ sectors.itens_next_check }} 
          </label>
        </div>

        <div class="flex items-center">
          <div class="h-2.5 w-2.5 rounded-full me-2 bg-red-500"></div>
          expirados:
          <label class="text-red-500 font-semibold ml-2"> 
            {{ sectors.itens_expired_at }} 
          </label>
        </div>
      </p>
      
      <a
        @click="$emit('setList', sectors.id)"
        title="Ver todos os itens"
        class="inline-flex anim items-center px-3 py-2 -mt-2 text-sm font-semibold text-center text-white bg-gradient-to-r to-[#93cd24] from-[#0c7036] rounded-lg hover:bg-green-700 focus:ring-4 focus:outline-none focus:ring-blue-300 cursor-pointer"
      >
        Ver itens
        <component class="ml-1 font-semibold w-4 h-4" :is="PhArrowRight" />
      </a>
    </div>
  </div>
</template>

<script setup>
import { storeApp } from "@/store";
import { showToast as toast } from "@/helpers/UseToasts";
import {
  PhClockAfternoon as ClockIcon,
  PhCheckCircle as CheckIcon,
  PhGearSix,
  PhArrowRight,
  PhDotsThreeOutline,
} from "@phosphor-icons/vue";
import { initFlowbite } from "flowbite";
import { ref } from "vue";
import { defineProps } from "vue";
import { onMounted } from "vue";
import ExtinguisherService from "../../service/extinguisher.service";
import { dataExtinguisher } from "../../store";

const defaultBg = require('@/assets/img-default-sectors.webp');
const imageServe = process.env.VUE_APP_IMAGE_SERVE + "storage/";
const props = defineProps({
  id: {
    type: Number,
    required: true,
  },
  sectors: {
    type: [Array, Object],
    required: true,
  },
});

async function removeSector(id) {
  storeApp.state.loading = true

  await ExtinguisherService.removeSector(id)
  .then(res => {
    if (res?.data?.success) {
      dataExtinguisher.dispatch('setAllSectors', res?.data?.sectors)
      
      toast(
        'Sucesso',
        res.data.message,
        'success'
      )
    }
    
    storeApp.state.loading = false
  }).catch(err => {
    storeApp.state.loading = false

    if (err?.response?.data?.error && err.response.data.status === 400) {
      return toast(
        'Aviso',
        err.response.data.message,
        'error'
      )
    }

    return toast(
      'Aviso',
      'Algo deu errado ao remover setor',
      'error'
    )
  })

}

onMounted(() => {
  initFlowbite();
});
</script>

<style lang="scss">
.anim {
  transition-duration: .5s;

  &:hover {
    transform: translateY(-5px);
    transition-duration: 0.3s;
  }
}
</style>
